import styled from 'styled-components';
import Loading from '../../common/components/Loading';
import React from 'react';
import { Configuration } from '../../common/clients/ogg';
import WorkOsAuthenticationProvider from '../services/workosAuthentication.service';
import { useWorkOsAuth } from '../../common/hooks/workosAuthProvider';
import MainHeader from '../components/MainHeader';
import SignIn from '../components/SignIn';
import { ProfileService } from '../../common/services/profile.service';
import { useToast } from '../../common/hooks/useToast';
import { Outlet } from 'react-router-dom';
import config from '../config.json';
import { useTeachingService } from '../components/Teach';
import { ProfileServiceContext } from '../../common/hooks/useProfileService';

export const MainViewContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding-left: 1rem;
  padding-right: 1rem;
  max-width: 1600px;
  width: 100%;
`;

export default function MainView() {
  const authContext = useWorkOsAuth();
  const toastProvider = useToast();
  const teachingService = useTeachingService();

  if (authContext == null) return <Loading title='Setting up Ogg' subtitle='just a sec'></Loading>;

  const authProvider = new WorkOsAuthenticationProvider(authContext);

  const apiConfig = new Configuration({
    basePath: config.OggApiUrl,
    accessToken: () => authProvider.getBearerToken(),
  });

  var profileService = new ProfileService(apiConfig, toastProvider, authProvider);

  console.debug('loading main view');

  return (
    <div className='flex-row justify-center full-width full-height'>
      <ProfileServiceContext.Provider value={profileService}>
        <MainViewContainer>
          <MainHeader authContext={authContext} profileService={profileService}></MainHeader>
          <SignIn
            isSignedIn={!!authContext.user}
            login={authContext.openLogin}
            signUp={authContext.openSignup}
          />

          {!!authContext.user && <Outlet />}
        </MainViewContainer>
      </ProfileServiceContext.Provider>
    </div>
  );
}
